import { Card, CardContent, CardHeader, CardTitle } from "@lawline/ui/components/card";
import { useTranslations } from "use-intl";

import type { UsageTotals } from "../usage.types";
import { formatTokens } from "../usage.utils";

// `key` indexes UsageTotals; `labelKey` resolves the "usage.summary" label.
const STATS = [
	{ key: "lawline", labelKey: "lawlineTokens" },
	{ key: "tokens", labelKey: "tokens" },
	{ key: "requests", labelKey: "requests" },
] as const;

export function UsageSummaryCards({ totals }: { totals: UsageTotals }) {
	const t = useTranslations("usage.summary");

	return (
		<div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
			{STATS.map((s) => (
				<Card key={s.key}>
					<CardHeader>
						<CardTitle className="text-muted-foreground text-sm font-medium">
							{t(s.labelKey)}
						</CardTitle>
					</CardHeader>
					<CardContent>
						<p className="font-mono text-2xl font-semibold tabular-nums">
							{formatTokens(totals[s.key])}
						</p>
					</CardContent>
				</Card>
			))}
		</div>
	);
}
